import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper.tsx";
import { useDeleteEntityTemplateStepDialog } from "./DeleteEntityTemplateStepDialog.hooks.ts";
import { useTranslation } from "../../../localization/useTranslation.ts";

export interface DeleteEntityTemplateStepDialogProps {
    entityTemplateId: string;
    stepId: string;
    stepName: string;
    onCloseDialog: () => void;
    onStepDeleted: () => void;
}

function DeleteEntityTemplateStepDialog(props: DeleteEntityTemplateStepDialogProps) {
    const { translateString } = useTranslation();
    const { isDeleting, onDeleteStep } = useDeleteEntityTemplateStepDialog(props);

    return (
        <DotLegalDeleteDialogWrapper
            itemForDeletion={props.stepName}
            open
            onDialogClose={props.onCloseDialog}
            onOkClick={onDeleteStep}
            inProgress={isDeleting}
            additionalWarning={translateString("deleteStepFromEntityTemplateWarning")}
        />
    );
}

export default DeleteEntityTemplateStepDialog;
